import { configureStore } from '@reduxjs/toolkit';

import accountReducer from './reducers/account/slice';
import anonQrReducer from './reducers/anonQr/slice';
import appReducer from './reducers/app/slice';
import appsReducer from './reducers/previewScreens/apps';
import imagesReducer from './reducers/previewScreens/images';
import listOfLinksReducer from './reducers/previewScreens/list-of-links';
import pdfReducer from './reducers/previewScreens/pdf';
import socialMediaReducer from './reducers/previewScreens/social-media';
import vCardPlusReducer from './reducers/previewScreens/vcard-plus';
import websiteReducer from './reducers/previewScreens/website';
import qrCodeReducer from './reducers/qr-code';
import stepperReducer from './reducers/stepepr';

export const store = configureStore({
  reducer: {
    app: appReducer,
    anonQr: anonQrReducer,
    accountReducer,
    pdfReducer,
    appsReducer,
    imagesReducer,
    qrCodeReducer,
    stepperReducer,
    websiteReducer,
    socialMediaReducer,
    listOfLinksReducer,
    vCardPlusReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
